import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const WhatWeOffer = ( props ) => {
  const { classes } = props;

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>What we offer</h3>
              <p className={classes.aboutUsText}>
                We support governments and development partners to generate and use rigorous evidence that informs better policies, programs and investments. Our work spans the full decision-making cycle, helping identify what works, why it works, and how to improve outcomes.
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}what-we-offer`}
              >
                Explore What we offer
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <ul className={classes.aboutUsListGrid}>
                <li><a href={`${SITE_LINK}what-we-offer?solution=theory-of-change-development`} rel="noopener noreferrer">Theory of change development</a></li>
                <li><a href={`${SITE_LINK}what-we-offer?solution=impact-evaluation`} rel="noopener noreferrer">Impact evaluation</a></li>
                <li><a href={`${SITE_LINK}what-we-offer?solution=evidence-synthesis`} rel="noopener noreferrer">Evidence Synthesis</a></li>
                <li><a href={`${SITE_LINK}what-we-offer?solution=evidence-gap-maps`} rel="noopener noreferrer">Evidence gap maps</a></li>
                <li><a href={`${SITE_LINK}what-we-offer?solution=impact-evaluations-scoping-and-design`} rel="noopener noreferrer">Impact evaluations scoping and design</a></li>
                <li><a href={`${SITE_LINK}what-we-offer?solution=training-initiatives`} rel="noopener noreferrer">Training Initiatives</a></li>
                <li><a href={`${SITE_LINK}what-we-offer?solution=research-grants-administration`} rel="noopener noreferrer">Research grants administration</a></li>
                <li><a href={`${SITE_LINK}what-we-offer?solution=transparency-research-and-ethics-helpdesk`} rel="noopener noreferrer">Transparency, research and ethics helpdesk</a></li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

WhatWeOffer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles( styles )( WhatWeOffer );
